export default __webpack_public_path__ + "assets/images/bsv-icon-16f1e421851231593f6a3798e2aac859.svg";